import $ from "jquery";

$(() => {
  if (document.querySelector('.overlapped-background-image')) {
    const imgParallax = () => {
      if ( $(window).width() >= 768 ) {
        const overlaps = $(".overlapped-background-image")
        overlaps.each(function() {
          const image = $(this).children(".img-container");
          let overlapTop = $(this).offset().top;
          let scrollPosition = $(window).scrollTop() + $(window).height() - overlapTop;
          let margin = null;
  
          if ( scrollPosition > 0 ) {
            margin = (scrollPosition / $(window).height() * 180);
          } else {
            margin = 0;
          }
  
          margin = margin + "px";
          image.css("bottom", margin);
        });
      } else {
        $(".img-container").css("bottom", "0");
      }
    }

    $(window).on("scroll", function () {
      imgParallax();
    });
    $(window).on("resize", function() {
      imgParallax();
    })
  }
});